import { BlankLayout } from '@/components/layouts';

export default {
  path: '/live',
  name: 'live',
  component: BlankLayout,
  meta: {
    module: '直播',
  },
  children: [
    {
      path: '/live/LiveDetail/:type/:id',
      name: 'live.LiveDetail',
      component: () => import(/* webpackChunkName: 'enroll' */ '@/views/live/LiveDetail.vue'),
      meta: {
        title: '直播详情',
        titleAlias: '直播详情',
        hideBanner: true,
      },
    },
  ],
};
